import { Button } from '@trmediaab/zebra';

interface TextButtonProps extends React.ComponentProps<typeof Button> {
  label: string;
}

const TextButton = ({ label, ...props }: TextButtonProps) => (
  <Button width="100%" color="link.primary" justifyContent="center" {...props}>
    {label}
  </Button>
);

export default TextButton;
